import React from 'react';
import './App.css';
import Router from './Route';

function App() {
  return (
    <>
    
      <Router />
    </>
  );
}

export default App;